// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__g09Jq","rootSuccess":"CompleteLink_rootSuccess__SPbD-","rootFailure":"CompleteLink_rootFailure__1rhV0","isDisabled":"CompleteLink_isDisabled__1bIOL"};